import { openPopupExterior } from "./popup";

let elPoints = [];
let exteriorData;
let touchMoved = false;

function getContainer() {
  return document.getElementById("j360_points");
}

// init exterior points.
export function initPoints(data, frame) {
  // -- delete points
  reset();

  if (!data) {
    return;
  }

  exteriorData = data;

  const container = getContainer();

  // -- create elements
  let i = 0;
  for (const key in data?.hotspots) {
    if (!Object.hasOwnProperty.call(data.hotspots, key)) {
      continue;
    }

    const hotspot = data.hotspots[key];

    const elPoint = document.createElement("div");
    elPoint.classList.add("j360-point");

    // add listener to open popup.
    elPoint.addEventListener("click", function (ev) {
      const popup = hotspot.popup - 1;
      openPopupExterior(popup);
    });

    elPoint.addEventListener("touchstart", function (ev) {
      touchMoved = false;
    });

    elPoint.addEventListener("touchmove", function (ev) {
      touchMoved = true;
    });

    elPoint.addEventListener("touchend", function (ev) {
      if (!touchMoved) {
        const popup = hotspot.popup - 1;
        openPopupExterior(popup);
      }
    });

    // -- set data
    elPoint.setAttribute("data-hotspot", JSON.stringify(hotspot));

    // -- append points to container
    container.appendChild(elPoint);
    elPoints.push(elPoint);

    i++;
  }

  render(frame);
}

function reset() {
  getContainer().innerHTML = "";
  elPoints = [];
}

export function hide() {
  elPoints.forEach((elPoint) => {
    // set left and top for each points.
    elPoint.style.display = "none";
  });
}

// render and set positions.
export function render(frame) {
  elPoints.forEach((elPoint, i) => {
    const hotspotString = elPoint.getAttribute("data-hotspot");
    // Parse the JSON string to get the object
    const hotspot = JSON.parse(hotspotString);

    // get hotspot locations
    const point = hotspot.point ?? [];

    // get hotspot location for current frame
    if (!point[frame]) {
      elPoint.style.display = "none";
      return;
    } else {
      elPoint.style.display = "block";
    }

    // set left and top of point.
    const x = point[frame][0] ?? 0;
    const y = point[frame][1] ?? 0;

    if (null === x || null === y) {
      elPoint.style.display = "none";
      return;
    }

    elPoint.style.left = x + "%";
    elPoint.style.top = y + "%";
  });
}
